// angular
import { Injectable } from '@angular/core';

// services
import { ApiService } from './api.service';

// models
import { IAnalytics, IUser, IPartner, IPartnerCreate, IPartnerUpdate } from '@shared/models';
import { Observable } from 'rxjs';

@Injectable()
export class InvestorService {
  constructor(private apiService: ApiService) {}

  getAllUsers(): Observable<IUser[]> {
    return this.apiService.get(`/users`);
  }

  getAnalytics(): Promise<IAnalytics> {
    // TODO: Rewrite to Observable
    return this.apiService.get('/analytics').toPromise();
  }

  // Partner management methods
  getPartners(): Observable<IPartner[]> {
    return this.apiService.get2('/partners');
  }

  getPartner(partnerId: number): Observable<IPartner> {
    return this.apiService.get2(`/partners/${partnerId}`);
  }

  createPartner(partnerCreate: IPartnerCreate): Observable<IPartner> {
    return this.apiService.post2('/partners', partnerCreate);
  }

  updatePartner(partnerId: number, partnerUpdate: IPartnerUpdate): Observable<IPartner> {
    return this.apiService.put2(`/partners/${partnerId}`, partnerUpdate);
  }

  deletePartner(partnerId: number): Observable<void> {
    return this.apiService.delete2(`/partners/${partnerId}`);
  }
}
